import Vue from 'vue'
import App from './App.vue'

import router from './router'
import axios from 'axios'
import 'lib-flexible'
import './assets/css/base.css'

Vue.config.productionTip = false
let http = axios.create({
  // baseURL: 'http://dev.pubdatamall.com/openapi',
  baseURL: 'https://api.pubdatamall.com/',
 
});
Vue.prototype.$http = http

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
